// extracted by mini-css-extract-plugin
export var csatScore = "_mo-5";
export var header = "_mo-1";
export var panelWrapper = "_mo-2";
export var postPreview = "_mo-3";
export var rightContent = "_mo-0";
export var wrappingText = "_mo-4";